<div class="w-100 h-100">
  <div class="lang-switch">
    @if (locale === "en") {
      <img
        class="ls-btn"
        width="32"
        height="22"
        alt="GR"
        [ngSrc]="'GR' | tuiFlag"
        (click)="setLocale('el')"
      />
    }
    @if (locale === "el") {
      <img
        class="ls-btn"
        width="32"
        height="22"
        alt="EN"
        [src]="'GB' | tuiFlag"
        (click)="setLocale('en')"
      />
    }
  </div>
  <router-outlet></router-outlet>
</div>
